// extracted by mini-css-extract-plugin
var _1 = "TopicPosts-module__isEditing--zwxXd";
export { _1 as "isEditing" }
